var randomTestimonals = document.querySelectorAll('.random-testimonal')

var randomTestimonal = (function displayRandomTestimonal() {
  
  var testimonalNumToDisplay = Math.floor((Math.random() * randomTestimonals.length)); 

  randomTestimonals[0].classList.add('hidden')
  randomTestimonals[testimonalNumToDisplay].classList.remove('hidden') 
}());